import {React, Component} from 'react'
import {BrowserRouter as Router, Link} from "react-router-dom";


import pxgGif from '../../assets/pxg.gif'
import './Footer.css';


class Footer extends Component {
  constructor(props){
    super(props)
    this.state = {
        colors : ["cornflowerblue", "plum", "lightgrey", "burlywood", "mediumpurple", "darkseagreen", "lightcoral"]
    }
    
  }


  render(){
    return (
      <div style={{backgroundColor: this.state.colors[Math.floor(Math.random() * this.state.colors.length)] }} className="Footer">
                              

        built by <a href="https://twitter.com/0xSham">0xSham</a>                      
        
         
      </div>
                              
    
    );
  
  }
}

export default Footer;
